import {
  IFavoriteDataRequest,
  IFavoriteUpdateRequest,
} from "../../schemas/Favorite/Favorite.Schema";

export class Favorite implements IFavoriteDataRequest {  
  page: number = 0;
  sortColumn: string = "pickupdate";
  favourite: boolean = true;
  userID?: string;
  carrierId?: string;
  size?: number;

  getFavoritePayload() {
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function") input[key] = value;
    }
    return {
      query: {
        findUserFavouriteSearchHistory: {
          __args: {
            input,
          },
          id: true,
          userid: true,
          originState: true,
          originCity: true,
          originPostalCode: true,
          originCountry: true,
          originradius: true,
          pickupdate: true,
          destinationCity: true,
          destinationState: true,
          destinationPostalCode: true,
          destinationCountry: true,
          destinationradius: true,
          dropdate: true,
          trailertype: true,
          searchdate: true,
          favouritesearchindicator: true,
          carrierid: true,
          durationDays: true,
          pickupStartDate: true,
          pickupEndDate: true,
          pickupDateOffset: true,
          dropStartDate: true,
          dropEndDate: true,
          dropDateOffset: true,
          destinationState1: true,
          destinationState2: true,
          destinationState3: true,
        },
      },
    };
  }

  updateFavoriteLoad(data: IFavoriteUpdateRequest) {
    return {
      mutation: {
        updateUserSearchHistory: {
          __args: {
            input: data,
          },
          id: true,
        },
      },
    };
  }

  updateFavoriteLoadCheckDuplicate(data: IFavoriteUpdateRequest) {
    return {
      mutation: {
        updateUserSearchHistoryAsFavorite: {
          __args: {
            input: data,
          },
          errorMessage: true,
          status: true,
          userSearchHistory: {
            id: true,
          },
        },
      },
    };
  }
}
